var NavDrawerController = require('./controller.js');
var NavDrawerSlideStorage = require('./slide-storage.js');
var carouselId = '#nav-drawer-carousel';
var navDrawerCtrl = new NavDrawerController();

var SponsorshipConst = require('src/interlock/nav-sponsorship/constants');
var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');

$('#nav-drawer').on('hidden.bs.modal', function() {
    $(carouselId).carousel(0);
    navDrawerCtrl.headerState(0);
    NavDrawerSlideStorage.clearQueue();
});

$('#nav-drawer .slide-back').on('click', function(e) {
    e.preventDefault();
    var popQueue = NavDrawerSlideStorage.popQueue() || 0;

    if(SponsorshipConst.SLIDE_TRACKING_NUMBERS.indexOf(popQueue) > -1) {
        eventToolbox.fireCustomEvent(SponsorshipConst.EVENT_TYPE_FIRE_IMPRESSION_TRACKING, {});
    }
    navDrawerCtrl.headerState(popQueue);
    $(carouselId).carousel(popQueue);
});

$('#nav-drawer-carousel .carousel-item .list-group > a').on('click', function(e) {
    var href = $(this).attr('href');
    if(!href) {
        e.preventDefault();
        navDrawerCtrl.listGroupItemSelect(this);
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/interlock/nav/drawer/nav.js
// module id = 70
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14